
import './App.css';
import { useEffect } from 'react';

import ManagePromotions from "./Pages/ManagePromotions";
import ClubManagement from './Pages/ClubManagement';
import StartPage from './Pages/StartPage';
import LoginPage from './Pages/Login';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { UrlContext } from './context/urlContext';
import UrlHelper from './Components/UrlHelperClass';
import MainLayout from './Layout/MainLayout';
import PrivateRouteWithLayout from './Layout/PrivateRouteWithLayout'
import ClubScope from './Layout/ClubScope';
import ClubFlatRedirect from './Components/ClubFlatRedirect';
import PrinterMake from './Pages/PrinterMake';
import { ErrorDisplayProvider } from './Components/ErrorDisplay';
import Notifier from './Components/Notifier';
import { ConfirmProvider } from './Components/ConfirmDialog';
import Report from './Pages/Report';
import SummaryReport from './Pages/SummaryReport';
import GeneralReport from './Pages/GeneralReport';
import SinglePassCreation from './Pages/SinglePassCreation';
import GrantSingleMember from './Pages/GrantSingleMember';
import { AuthProvider } from './context/authContext';


let UrlHelperObj = new UrlHelper();

function App() {
  useEffect(() => {
    document.title = 'OmniQpon';
  }, []);

  return (
    <AuthProvider>
    <Router>
      <ErrorDisplayProvider value={{
    errorMessage:'',
    loading:false
}} >
        <UrlContext.Provider value={{ UrlHelperObj }}>
        <ConfirmProvider>
        <Notifier />
        {/* <Navbar /> */}

        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <PrivateRouteWithLayout exact path="/" layout={MainLayout} component={StartPage} />
          <Route exact path="/S7000Config"><ClubFlatRedirect slug="s7000" /></Route>
          <PrivateRouteWithLayout exact path="/ClubManagement" layout={MainLayout} component={ClubManagement} allowedRoles={[100]} />
          {/* Superadmin flat page with its own club selector (+ "All clubs") — no requiresClub. */}
          <PrivateRouteWithLayout exact path="/SummaryReport" layout={MainLayout} component={SummaryReport} allowedRoles={[100]} />
          {/* Same pattern — its own club selector, so no requiresClub. Single club
              only in phase 1; "All clubs" arrives with phase 2. */}
          <PrivateRouteWithLayout exact path="/GeneralReport" layout={MainLayout} component={GeneralReport} allowedRoles={[100]} />
          <Route path="/club/:issuerId" component={ClubScope} />
          <Route exact path="/UserManagement"><ClubFlatRedirect slug="users" /></Route>
          <PrivateRouteWithLayout exact path="/ManagePromotions"  layout={MainLayout} 
                          component={ManagePromotions} allowedRoles={[100,101]} requiresClub />
          <Route exact path="/RedemptionPartner"><ClubFlatRedirect slug="redemption-partner" /></Route>
          <Route exact path="/ManageLocations"><ClubFlatRedirect slug="locations" /></Route>
          <PrivateRouteWithLayout exact path="/PrinterMake" layout={MainLayout}
                          component={PrinterMake} allowedRoles={[100]} requiresClub />
          <Route exact path="/PromotionLocation"><ClubFlatRedirect slug="promotion-location" /></Route>
          <PrivateRouteWithLayout exact path="/SinglePass" layout={MainLayout}
                          component={SinglePassCreation} allowedRoles={[100,101,102]} requiresClub />
          <PrivateRouteWithLayout exact path="/GrantSingleMember" layout={MainLayout} 
                          component={GrantSingleMember} allowedRoles={[100,101,102]} requiresClub />
          {/* Superadmin-only; keep in sync with PAGE_ROLES.reports in ClubScope.js. */}
          <PrivateRouteWithLayout exact path="/Reports" layout={MainLayout}
                          component={Report} allowedRoles={[100]} requiresClub />
                          
        </Switch>
        </ConfirmProvider>
        </UrlContext.Provider>
    </ErrorDisplayProvider>
  </Router>
  </AuthProvider>
  );
}

export default App;
